import { render, staticRenderFns } from "./LeaderboardPlayerBox.vue?vue&type=template&id=17ff5012&scoped=true&"
import script from "./LeaderboardPlayerBox.vue?vue&type=script&lang=js&"
export * from "./LeaderboardPlayerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff5012",
  null
  
)

export default component.exports